import type { Messages } from './en';

export const MESSAGES_HU: Messages = {
  secure_tagadapay: 'Biztonságos Fizetés a Tagada-szal',
  checkout_title: 'Biztonságos Fizetés',
  checkout_subtitle: 'Fejezze be vásárlását biztonságosan',
  express_payment: 'Expressz Fizetés',
  express_payment_apple_pay: 'Fizetés Apple Pay-jel',
  express_payment_subtitle: 'Ugrás a fizetési űrlap felett',
  informations_title: 'Információk',
  informations_subtitle: 'Adja meg személyes adatait',
  shipping_address_title: 'Szállítási Cím',
  shipping_address_subtitle: 'Adja meg szállítási címét',
  shipping_method_title: 'Szállítási Mód',
  shipping_method_subtitle: 'Válassza ki szállítási módját alább',
  shipping_method_warning_title: 'Információ',
  shipping_method_warning_text: 'Nem található szállítási mód az Ön országában',
  billing_address_check: 'A számlázási cím eltér a szállítási címtől',
  billing_method_title: 'Számlázási Mód',
  billing_method_subtitle: 'Adja meg számlázási címét',
  payment_title: 'Fizetés',
  payment_subtitle: 'Válassza ki fizetési módját alább. Minden tranzakció biztonságos és titkosított',
  payment_credit_card: 'Hitel- vagy bankkártya',
  payment_credit_card_subtitle: 'Biztonságos kártyás fizetés',
  payment_paypal_subtitle: 'Biztonságos és gyors fizetés PayPal-lal',
  payment_bridge_subtitle: 'Biztonságos és gyors fizetés Bridge-dzsel',
  payment_klarna_subtitle: 'Biztonságos és gyors fizetés Klarna-val',
  payment_generic_subtitle: 'Biztonságos és gyors fizetés',
  default_payment_method_short: 'Alapértelmezett',
  order_summary_discount_code: 'Kedvezménykód',
  order_summary_discount_discovered_callout: 'Kedvezménykódokat találtunk Önnek!',
  order_summary_discount_discovered_callout_action: 'Mindegyik hozzáadása',
  order_summary_title: 'Az Ön rendelése',
  order_summary_subtotal: 'Részösszeg',
  order_summary_shipping: 'Szállítás',
  order_summary_discount: 'Kedvezmény',
  order_summary_tax: 'Becsült adók',
  order_summary_total: 'Összesen',
  order_summary_total_savings: 'Megtakarítások',
  button_pay: 'Fizetés most',
  button_pay_with_gateway: 'Fizetés {gateway}-vel',
  loading: 'Betöltés...',
  error_missing_checkout_session_id: 'Hiányzó pénztár munkamenet azonosító',
  error_checkout_session_not_found: 'Pénztár munkamenet nem található',
  error_order_already_completed: 'Rendelés már befejezve',
  error_checkout_session_items_empty: 'A kosara üres',
  order_not_found: 'Rendelés nem található',
  thank_you_title: 'Köszönjük rendelését!',
  thank_you_subtitle: 'Rendelését sikeresen feldolgoztuk.',
  thank_you_email_sent: 'Megerősítő e-mailt küldtünk regisztrált e-mail címére:',
  thank_you_order_details: 'Rendelés Részletei',
  thank_you_reference: 'Hivatkozás',
  thank_you_date: 'Dátum',
  thank_you_total: 'Összesen',
  thank_you_button_continue: 'Vásárlás Folytatása',
  term_and_privacy_clicking_text: 'Kattintással elfogadom',
  term_and_condition_link_text: 'Általános Szerződési Feltételek',
  privacy_policy_link_text: 'Adatvédelmi Irányelvek',
  refund_policy_link_text: 'Visszatérítési Szabályzat',
  shipping_policy_link_text: 'Szállítási Szabályzat',
  billed_as_text: 'Hitelkártyája {domain} néven lesz terhelve.',
  you_must_accept_policies: 'El kell fogadnia',
  and: 'és',
  comma: ',',
  payment_error_title: 'Hiba',
  checkout_preview_title: 'Előnézet Mód - Ez egy tervezet pénztár oldal',
  order_summary_discount_code_apply_button: 'Alkalmaz',
  optional: 'Opcionális',
  field_phone: 'Telefon',
  field_phone_placeholder: 'Adja meg telefonszámát',
  field_phone_required_text: 'Telefonszám kötelező',
  field_company: 'Cég',
  field_company_placeholder: 'Adja meg cége nevét',
  checkbox_billing_address: 'A számlázási cím eltér a szállítási címtől',
  billing_address_title: 'Számlázási Cím',
  billing_address_subtitle: 'Adja meg számlázási címét',
  field_first_name: 'Keresztnév',
  field_first_name_placeholder: 'Adja meg keresztnevét',
  field_first_name_error_message: 'Ez a mező kötelező',
  field_last_name: 'Vezetéknév',
  field_last_name_placeholder: 'Adja meg vezetéknevét',
  field_last_name_error_message: 'Ez a mező kötelező',
  field_address: 'Cím',
  field_address_placeholder: '123 Fő utca, Város, Ország',
  field_address_error_message: 'Ez a mező kötelező',
  field_additional_address: 'További Cím',
  field_additional_address_placeholder: 'Lakás, lakosztály, egység, stb.',
  field_additional_address_error_message: 'Ez a mező kötelező',
  field_city: 'Város',
  field_city_placeholder: 'Adja meg városát',
  field_city_error_message: 'Ez a mező kötelező',
  field_country: 'Ország',
  field_country_error_message: 'Ez a mező kötelező',
  field_state: 'Állam/Megye',
  field_state_placeholder: 'Adja meg államát/megyéjét',
  field_state_error_message: 'Ez a mező kötelező',
  field_postal_code: 'Irányítószám',
  field_postal_code_placeholder: 'Adja meg irányítószámát',
  field_postal_code_error_message: 'Ez a mező kötelező',
  field_email: 'E-mail',
  field_email_placeholder: 'Adja meg e-mail címét',
  field_email_error_message: 'Ez a mező kötelező',
  credit_card_method: 'Hitel- vagy bankkártya',
  card_error_message: 'Érvénytelen kártya információ',
  card_number: 'Kártyaszám',
  card_number_placeholder: 'Adja meg kártyaszámát',
  card_number_error_message: 'Ez a mező kötelező',
  expiry_date: 'Lejárati dátum',
  expiry_date_placeholder: 'HH/ÉÉ',
  expiry_date_error_message: 'Ez a mező kötelező',
  expiry_date_error_message_expired: 'A lejárati dátum elmúlt',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'A CVC 3 vagy 4 számjegyű kell legyen',
  payment_methods_loading_error: 'Nem sikerült betölteni a fizetési módokat',
  recommanded: 'Ajánlott',
  free: 'Ingyenes',
  customer_update_error: 'Nem sikerült frissíteni az információkat',
  shipping_method_empty_country: 'Válasszon országot az elérhető szállítási módok megtekintéséhez',
  shipping_method_update_error: 'Nem sikerült frissíteni a szállítási mód információit',
  items: '{count} tétel',
  back: 'Vissza',
  continue_to_shipping: 'Tovább a szállításhoz',
  continue_to_payment: 'Tovább a fizetéshez',
  contact_title: 'Kapcsolat',
  contact_title_subtitle: 'Adja meg kapcsolati információit',
  pay_now: 'Fizetés most',
  secure_payment_message: 'Minden tranzakció biztonságos és titkosított',
  interval_day: 'nap',
  interval_week: 'hét',
  interval_month: 'hónap',
  interval_year: 'év',
  interval_day_plural: 'nap',
  interval_week_plural: 'hét',
  interval_month_plural: 'hónap',
  interval_year_plural: 'év',
  every_interval: 'Minden {count} {interval}',
  billing_every_interval: 'Számlázás minden {count} {interval}',
  delivery_every_interval: 'Szállítás minden {count} {interval}',
  free_trial_period: '{duration} {type} ingyenes próba',
  first_payment_free: 'Első fizetés ingyenes',
  subscription_trial_notice:
    'Az előfizetése ingyenes próbaidőszakot tartalmaz. Nem számítunk fel díjat a próbaidőszak végéig.',
  recurring_total_with_interval: 'Ismétlődő összeg (minden {count} {interval})',
  trial_ends_on: 'A próbaidőszak {date}-án/én ér véget',
  billing_timing: 'Számlázás: {timing}',
  billing_cycle_anchor: 'Számlázási ciklus horgony',
  field_marketing_label: 'Beleegyezek marketing e-mailek fogadásába',
  terms_acceptance_text: 'Kattintással elfogadom',
  cart_title: 'Kosár',
  payment_failed_message: 'A fizetés sikertelen',
  email: {
    abandoned_checkout: {
      preview: 'Fejezze be vásárlását',
      default_body: 'Észrevettük, hogy tételeket hagyott a kosarában. Szeretné befejezni vásárlását?',
      cart_title: 'Az Ön Kosara',
      quantity: 'Mennyiség',
      recurring: 'Ismétlődő {interval}ente',
      trial_period: '({duration} {type} próba)',
      subtotal: 'Részösszeg',
      discounts: 'Kedvezmények',
      total: 'Összesen',
      cta_button: 'Vásárlás befejezése',
      footer_text: 'Ha kérdése van, egyszerűen válaszoljon erre az e-mailre - mindig szívesen segítünk.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'Jogosulatlan',
      unsupported_content_type: 'Nem támogatott tartalomtípus',
      single_file_required: 'Egyetlen fájl szükséges',
      file_too_big: 'A fájl túl nagy',
      non_image_file: 'Nem kép fájlokat nem tudunk kezelni',
    },
  },
  promotion_code_invalid: 'Ez a kedvezménykód nem érvényes',
  applying: 'Alkalmazás...',
  processing_payment: 'Fizetés feldolgozása...',
  select_country: 'Válasszon országot',
  select_state: 'Válasszon államot',
  order_details: 'Rendelés részletei',
  order_number: 'Rendelésszám',
  order_date: 'Rendelés dátuma',
  email_confirmation: 'E-mail megerősítés',
  confirmation_sent_to: 'Megerősítő e-mail elküldve',
  shipping_address: 'Szállítási cím',
  billing_address: 'Számlázási cím',
  payment_successful: 'Sikeres fizetés',
  recurring_total: 'Ismétlődő összeg',
  payment_is_blacklisted: 'A fizetés tiltólistán van',
  checkout_has_errors_title: 'Érvényesítés',
  checkout_has_errors: 'Az alábbi információk érvénytelenek vagy hiányoznak',
  checkout_email_error: 'e-mail cím',
  checkout_shipping_address_error: 'szállítási cím',
  checkout_billing_address_error: 'számlázási cím',
  checkout_shipping_rate_error: 'szállítási díj',
  checkout_pickup_address_error: 'átvételi cím',
  checkout_payment_info_error: 'fizetési információk',
  checkout_phone_error: 'telefonszám',
  checkout_terms_error: 'nem fogadta el az általános szerződési feltételeket',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'Váratlan hiba történt. Kérjük, próbálja újra.',
  },
  checkout_completed_title: 'Fizetés Befejezve',
  checkout_already_completed: 'Ez a rendelés már ki lett fizetve',
  payment_completed: 'Fizetés Befejezve',
  apply_vip_offers: 'Fizetés VIP-ként',
  confirm_vip_payment: 'VIP Fizetés Megerősítése',
  cancel_vip_offers: 'VIP ajánlatok törlése',
  vip_total_difference: 'Különbség: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'VIP Megtakarítások',
  vip_savings_available: 'VIP Megtakarítások Elérhetőek',
  vip_savings_confirmed: 'VIP Megtakarítások Alkalmazva',
  vip_savings_message: 'Válassza a VIP fizetést ezen megtakarítások feloldásához!',
  vip_savings_applied_message: '{amount}-t takarít meg VIP előnyökkel!',
  vip_offer_savings_confirmed: 'VIP Ajánlat Alkalmazva',
  vip_offer_savings_available: 'VIP Ajánlat Elérhető',
  vip_offer_savings_message: 'Alkalmazza a VIP ajánlatot hogy megtakarítson rendelésén',
  vip_offer_savings_applied_message: '{amount}-t megtakarított a VIP ajánlattal',
  apply_vip_offer: 'VIP Ajánlat Alkalmazása',
  cancel_vip_offer: 'VIP Ajánlat Törlése',
  you_save: '{amount} megtakarítás',
  you_save_on_order: '{amount} megtakarítás rendelésén',
  you_save_available: 'Takarítson meg {amount}-t rendelésén az exkluzív VIP ajánlattal',
  free_trial_then_price: '{duration} {type} ingyenes próba, aztán {price}/{interval}',
  free_trial_period_short: '{duration} {type} ingyenes',
  click_to_apply: 'Kattintson az alkalmazáshoz',
  please_select_shipping_country: 'Kérjük válasszon országot az elérhető szállítási módok megtekintéséhez',
  invalid_phone_number: 'Érvénytelen telefonszám',
  click_errors_to_navigate: 'Kattintson a hibákra a navigáláshoz',
  pickup_point: 'Átvételi Pont',
  monday: 'Hétfő',
  tuesday: 'Kedd',
  wednesday: 'Szerda',
  thursday: 'Csütörtök',
  friday: 'Péntek',
  saturday: 'Szombat',
  sunday: 'Vasárnap',
  promotion_code_usage_limit_reached: 'Ez a promóciós kód elérte használati korlátját',
  promotion_code_first_time_only: 'Ez a promóciós kód csak új vásárlók számára érvényes',
  promotion_code_invalid_email: 'Ez a promóciós kód nem érvényes az Ön e-mail címére',
  promotion_code_cannot_apply: 'Ez a promóciós kód nem alkalmazható',
  promotion_code_already_applied: 'Ez a promóció már alkalmazva van',
  promotion_code_expired: 'Ez a promóciós kód lejárt',
  promotion_code_cannot_remove_auto: 'Automatikusan alkalmazott promóciókat nem lehet eltávolítani',
  promotion_code_remove_failed: 'Promóciós kód eltávolítása sikertelen',
  remove: 'Eltávolítás',
  pickup_select_point: 'Átvételi pont kiválasztása',
  pickup_select_point_description: 'Válasszon átvételi pontot a közelében',
  pickup_click_to_select: 'Kattintson a kiválasztáshoz',
  pickup_change_point: 'Átvételi pont módosítása',
  pickup_change: 'Módosítás',
  pickup_opening_hours: 'Nyitvatartás',
  pickup_closed: 'Zárva',
  pickup_point_error: 'Hiba történt az átvételi pont kiválasztásakor',
  pickup_view_list: 'Lista nézet',
  pickup_view_map: 'Térkép nézet',
  pickup_open_map: 'Térkép megnyitása',
  pickup_open_map_description: 'Kattintson az interaktív térkép megnyitásához',
  pickup_no_points_found: 'Nem találhatók átvételi pontok ezen a területen',
  cancel: 'Mégse',
  order_confirmed: 'Rendelés Megerősítve',
  view_order_details: 'Rendelés Részleteinek Megtekintése',
  back_to_portal: 'Vissza a Portálhoz',
  customer_details: 'Ügyfél Részletei',
  customer_email: 'E-mail',
  customer_id_label: 'Ügyfél Azonosító',
  customer_first_name: 'Keresztnév',
  customer_last_name: 'Vezetéknév',
  customer_locale: 'Nyelv',
  marketing_consent: 'Marketing Beállítások',
  marketing_accepted: 'Feliratkozott a marketingre',
  marketing_declined: 'Nem iratkozott fel a marketingre',
  customer_created_at: 'Ügyfél óta',
  order_status_label: 'Rendelés Állapota',
  order_status_paid: 'Fizetve',
  order_status_pending: 'Függőben',
  order_status_cancelled: 'Törölve',
  post_purchase: {
    title: 'Ezeket az ajánlatokat találtuk kifejezetten Önnek',
    view_deal: 'Ajánlat megtekintése',
    get_deal_now: 'Ajánlat megszerzése',
    bundle_content: '{count, plural, =0 {nincs tétel} =1 {# tétel} other {# tétel}}',
    adding_to_cart: 'Feldolgozás...',
    vip_only: 'Csak VIP',
    products: '{count, plural, =0 {Nincs termék} =1 {# termék} other {# termék}}',
    skip: 'kihagyás',
    skip_addition: 'menjen az összefoglaláshoz',
    exclusive_offer: 'Exkluzív egyszeri ajánlat',
    offer_expires_in: 'Az ajánlat lejár',
    minutes: 'perc',
    save: 'Megtakarítás',
    secure_checkout: 'Biztonságos fizetés',
    safe_payment: 'Vásárlóvédelem garantált',
    limited_time_offer: 'Korlátozott időre szóló ajánlat',
    previous: 'Előző',
    no_thanks: 'Nem köszönöm',
    offer_count: '{current}. ajánlat {total}-ból',
    special_offer_title: 'Különleges ajánlat Önnek',
  },
  billing_plan: 'Számlázási Terv',
  customer: 'Ügyfél',
  current_period: 'Jelenlegi Időszak',
  trial_period: 'Próbaidőszak',
  cancellation_notice: 'Lemondási Értesítés',
  subscription_cancellation_end_period: 'Ez az előfizetés a jelenlegi időszak végén lesz lemondva.',
  created: 'Létrehozva',
  product_id: 'Termék Azonosító',
  resuming: 'Folytatás...',
  resume_subscription: 'Előfizetés Folytatása',
  canceling: 'Lemondás...',
  cancel_subscription: 'Előfizetés Lemondása',
  my_subscriptions: 'Előfizetéseim',
  subscriptions: 'előfizetések',
  no_active_subscriptions: 'Nincsenek aktív előfizetései.',
  active: 'Aktív',
  trial: 'Próba',
  loading_subscriptions: 'Előfizetések betöltése...',
  qty: 'Db',
  id: 'Azonosító',
  by_canceling: 'A lemondással:',
  lose_club_advantages: 'Elveszíti a klubtagság minden előnyét',
  lose_accumulated_credits: 'Elveszíti az eddig felhalmozott krediteket',
  lose_promotion_code: 'Elveszíti személyes promóciós kódját exkluzív kedvezményekkel az egész boltban',
  confirm_proceed: 'Biztos, hogy folytatni szeretné?',
  cancel_club_membership: 'Ez lemondja klubtagságát a jelenlegi számlázási ciklus végén.',
  cancel_subscription_notice: 'Ez lemondja előfizetését a jelenlegi számlázási ciklus végén.',
  keep_subscription: 'Előfizetés Megtartása',
  yes_lose_benefits: 'Igen, el akarom veszíteni a Subclub tagság minden előnyét',
  yes_cancel: 'Igen, Lemondás',
  cancel_subscription_title: 'Előfizetés Lemondása',
  membership: 'Tagság',
  related_orders: 'Kapcsolódó Rendelések',
  related_orders_description: 'Vásárlás utáni ajánlatokon keresztül leadott rendelések',
  order_status: 'Állapot',
  order_total: 'Összesen',
  order_items: 'Tételek',
  order_type: 'Típus',
  view_order: 'Rendelés Megtekintése',
  order_item_count: '{count, plural, =1 {# tétel} other {# tétel}}',
  related_order_from: '{offerType} ajánlatból',
  no_related_orders: 'Nincsenek kapcsolódó rendelések',
  total_with_related_orders: 'Összesen kapcsolódó rendelésekkel',
  discount_applied: 'Kedvezmény alkalmazva',
  paid: 'Fizetve',
  pending: 'Függőben',
  processing: 'Feldolgozás alatt',
  cancelled: 'Törölve',
  refunded: 'Visszatérítve',
  vip_post_purchase: {
    title: 'Még van ideje!',
    subtitle: 'Iratkozzon fel klubtagságunkra és nyerjen nagyot!',
    action_cancel: 'Nem, köszönöm',
    action_subscribe: 'Feliratkozás',
    savings: '{amount} megtakarítás',
    offer_title: 'Exkluzív Egyszeri Ajánlat',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'Átvételi Pont Azonosító',
        name: 'Átvételi Pont Neve',
        street: 'Átvételi Pont Címe',
        type: 'Átvételi Pont Típusa',
        city: 'Átvételi Pont Városa',
        postal_code: 'Átvételi Pont Irányítószáma',
        country: 'Átvételi Pont Országa',
        carrier: 'Átvételi Pont Szállítója',
        code: 'Átvételi Pont Kódja',
        latitude: 'Átvételi Pont Szélessége',
        longitude: 'Átvételi Pont Hosszúsága',
      },
    },
  },
};
